import React, {Component, useState} from 'react'
import Button from '@mui/material/Button';
import {connect} from 'react-redux'

import i18n from "../../../i18nSetup";
import Tooltip from "@mui/material/Tooltip";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {JOURNEY_MODES} from '../../constants';

function SettingsPreview (props) {
    const { isOpen, query } = props;
    const journeyModesWithoutPreferences = [JOURNEY_MODES.bicycle, JOURNEY_MODES.car, JOURNEY_MODES.walk];

    return (
      <div id={'settings-btn'}>
        <Tooltip title={i18n.t('preferencesBtn')}>
          <Button sx={{
            color: isOpen ? '#4B33A5' : '#4F4F4F',
            borderColor: isOpen ? '#4B33A5' : '#EBEBEB',
            fontSize: 16,
            fontWeight: 400
          }} size={'small'} variant="outlined" onClick={props.onClick}
                  endIcon={isOpen ? (<ArrowDropUpIcon fontSize={'small'}/>) : (
                    <ArrowDropDownIcon fontSize={'small'}/>)} disabled={journeyModesWithoutPreferences.includes(query?.mode)}>
            {i18n.t('preferences')}
          </Button>
        </Tooltip>
      </div>
    )
  }

const mapStateToProps = (state, ownProps) => {
  return {
    config: state.otp.config,
    query: state.otp.currentQuery,
  }
}

const mapDispatchToProps = { }

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPreview)
